<template>
  <AppGenericInput
    v-model="selectedRoles"
    component-name="v-autocomplete"
    :items="roles"
    :label="label"
    v-bind="$attrs"
    no-filter
    item-text="name"
    item-value="id"
    hide-no-data
    outlined
    :filter-input="isFilter"
    hide-details
  />
</template>

<script>
import AppGenericInput from "./AppGenericInput.vue";
import { useRoleHelper } from "@composables/masterdata/person/roles";

export default {
  name: "AppSelectRoles",
  components: { AppGenericInput },
  props: {
    value: {
      type: [Object, String, Array],
      default: null
    },
    label: {
      type: String,
      default: "Active roles"
    },
    status: {
      type: Boolean,
      default: true
    },
    noSystem: {
      type: Boolean,
      default: true
    },
    haveScopes: {
      type: Array,
      default: () => []
    },
    active: {
      type: Boolean,
      default: false
    },
    isFilter: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },
  setup() {
    return {
      ...useRoleHelper()
    };
  },
  data() {
    return {
      menuProperties: {
        minWidth: 280
      }
    };
  },
  computed: {
    selectedRoles: {
      get() {
        return this.value;
      },
      set(vals) {
        this.$emit("input", vals);
      }
    },
    roles() {
      const roles = this.getRolesFromMaster({
        noSystem: this.noSystem,
        active: this.active
      });
      if (this.haveScopes.length) {
        return roles.filter(role => {
          if (this.haveScopes.length) {
            return role.allowedScopes.some(x => this.haveScopes.includes(x));
          }
          return true;
        });
      }
      return roles;
    }
  },
  created() {
    this.menuProperties.nudgeBottom = this.nudgeBottom;
  }
};
</script>
